import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GET_EMD_PASSENGER_RECEIPT_STORE_NAME, GetEmdPassengerReceiptState } from './get-emd-passenger-receipt.state';

/** Select GetEmdPassengerReceipt State */
export const selectGetEmdPassengerReceiptState = createFeatureSelector<GetEmdPassengerReceiptState>(
  GET_EMD_PASSENGER_RECEIPT_STORE_NAME
);

/** Select GetEmdPassengerReceipt isPending status */
export const selectGetEmdPassengerReceiptIsPendingStatus = createSelector(
  selectGetEmdPassengerReceiptState,
  (state) => !!state.isPending
);

/** Select GetEmdPassengerReceipt isFailure status */
export const selectGetEmdPassengerReceiptIsFailureStatus = createSelector(
  selectGetEmdPassengerReceiptState,
  (state) => !!state.isFailure
);
